export const SignupService = ({ BeURL, form, otp, isApproval, Setmessage, setConfirm, setIsAuth, setCurrentUser }) => {

    fetch(`${BeURL}/signup`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ fullName: form.fullName, email: form.email, contact: form.contact, password: form.password, otp: otp.join(""), isAgree: form.isAgree, isApproval})
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {               
                setIsAuth(true)
                setCurrentUser(data.user)
                Setmessage(data.message)
                setConfirm(true)
            }
            else {
                Setmessage(data.message)
                setConfirm(false)
            }
        })
        .catch(err => {
            console.log('Error in Singup:', err)
            alert('Trouble in connecting to the Server! Please try again later.')
        })

}
